import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY,
  REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT,
  REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_FEATURE_FLAG_UNIQUE_PASS
} from '../../config/settings/environment'

/**
 * The ProtectByFeatures' component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props
  const navigate = useNavigate()
  const features = {
    'com.seller/foreign.enrollment':
      REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT === true || REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT === 'true',
    'com.seller/recovery.admin':
      REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === true || REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === 'true',
    'com.seller/taxes.key.checks':
      REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === true || REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === 'true',
    'com.seller/unique.pass':
      REACT_APP_FEATURE_FLAG_UNIQUE_PASS === true || REACT_APP_FEATURE_FLAG_UNIQUE_PASS === 'true',
    'enable.civil.registry':
      REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY === true || REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY === 'true'
  }

  const result = rule(features)

  if (!result && redirectTo) {
    navigate(redirectTo, { replace: true })
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: () => true
}
ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
